<div class="flexBox" [style.width.px]="this.sizeIcon">
  @for (tag of tagsWithoutStory; track tag) {
    <div class="tooltip1">
      <img [src]="this.pathMapType[tag]" alt="quest icon" [style.width.px]="this.sizeIcon / tagsWithoutStory.length" />
      @if (tooltip) {
        <div class="top">
            {{tag}}<i></i>
        </div>
      }
    </div>
  }
  @if (isChapter){
    <div class="chapter">
      <div class="circle">
          <img [src]="'assets/book.svg'" class="size-img-book" alt="Icone histoire"/>
      </div>
    </div>
  }
</div>